import React, { useEffect, useState } from "react";
import { AdminEmployeeActiveList, HodPerformanceListAll } from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import { NonEmptyValidation } from "../../Store/validate";
import { Link } from "react-router-dom";
import { FinancialYearOptions, FinancialYearViewIndex } from "../Common/FinancialYear";
const AdminPerformanceList = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  useEffect(() => {
    getEmployeeList();
  },[]);

  const initialApplyState = {
    employee_ids: [],
    academic_year: [],
  };

  const [apply, setApply] = useState(initialApplyState);
  
  const [report, setReport] = useState({});
  const [validation, setValidation] = useState({});
  const [employee, setEmployee] = useState([]);
  const [editReport, setEditReport] = useState({});
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    setEditReport({ ...editReport, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getEmployeeList = async () => {
    const response = await AdminEmployeeActiveList(token);
    if (response && response.statusCode === 200) {
      let employee = response?.data?.employee_details.map((label) => ({
        label: label.first_name + " " + label.last_name,
        value: label.id,
      }));
      employee = [{ label: "All", value: "all" }, ...employee];
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.employee_ids = NonEmptyValidation(apply?.employee_ids);
    validate.academic_year = NonEmptyValidation(apply?.academic_year);

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...apply,
        employee_ids: apply?.employee_ids?.map((date) => date.value),
      };
      const response = await HodPerformanceListAll(Payload, token);
      if (response && response.statusCode === 200) {
        setReport(response.data?.report);
        successMsg(response.message);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-12">
                    <h6 className="labeltitle"> Performance Score Board Fixed</h6>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="labeltext"> Employee Name *</label>
                    <div>
                      <ReactSelect
                        isMulti
                        value={apply?.employee_ids}
                        onChange={(e) => {
                          setData(e, "employee_ids");
                        }}
                        options={
                          apply?.employee_ids?.some((v) => v?.value === "all")
                            ? [{ label: "All", value: "all" }]
                            : employee
                        }
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.employee_ids?.message
                        ? `Employee ${validation?.employee_ids?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <div>
                      <ReactSelect
                        isMulti={false}
                        value={{
                          label: apply.academic_year,
                          value: apply.academic_year,
                        }}
                        onChange={(selectedOption) =>
                          setData(selectedOption.value, "academic_year")
                        }
                        options={FinancialYearOptions()}
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3 mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Get Report
                    </button>
                  </div>
                </div>

                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Employee Name</th>
                      <th scope="col">Year</th>
                      <th scope="col">Application</th>
                      {/* <th scope="col">Edit</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {report?.length > 0 ? (
                      report &&
                      report?.map((apply, index) => (
                        <tr key={index}>
                          <td>{apply?.name ? apply?.name : "-"}</td>
                          <td>{apply?.academic_year ? FinancialYearViewIndex(apply?.academic_year) : "-"}</td>
                          <td className="viewoption">
                            <Link
                              to={`/app/admin/AdminPerformancereportspecificview/${apply?.id}`}
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td>
                          <div> No Data Found</div>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminPerformanceList;
